export type DraggableTouchCarouselHeight = `${number}px` | `${number}%` | null | undefined;

export enum DraggableTouchCarouselMouseEvent {
  mousedown = 'mousedown',
  mouseup = 'mouseup',
  mousemove = 'mousemove',
  mouseleave = 'mouseleave',
}

export enum DraggableTouchCarouselTouchEvent {
  touchstart = 'touchstart',
  touchmove = 'touchmove',
  touchend = 'touchend',
  touchcancel = 'touchcancel',
}

export const DraggableTouchCarouselLimit = 4.5;
export const DraggableTouchCarouselTouchMove = 2.5;
